import React from 'react'
import { ScrollView, Text, View } from 'react-native'
import { ImageComp } from '../../components/Image/Image';
import { getCleanUrl } from '../../utils/Helper';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';
import CustomPressable from '../../components/customPressable/customPressable';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { HEART } from '../../assets';

const SpaBookingSuccess = (props) => {
    const { currentWidget, selectedService, successResponse, updateReservationDetails, handleNext } = props;

    const { t } = useTranslation();
    const getStyles = useCssStyle();




    return (
        <View style={getStyles(['widgetRootContainer', 'spaBookingRootContainer'])} id='spaBookingRootContainer'>
            <HeaderWithBack />
            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'spaBookingMainContainer'])} 
                showsVerticalScrollIndicator={false}
                id='spaBookingMainContainer'
            >  
                <View style={getStyles(['widgetmainContainerHeaderContainer', 'spaBookingHeaderContainer'])} id='spaBookingHeaderContainer'>
                    {currentWidget?.widgetHeaderImageUrl && 
                        <ImageComp
                            source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} 
                            style={getStyles(['widgetmainContainerHeaderImg', 'spaBookingHeaderImg'])} id={"spaBookingHeaderImg"}
                        />
                    }
                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'spaBookingHeaderTitleContainer'])} id='spaBookingHeaderTitleContainer'>
                        <ImageComp source={HEART} style={getStyles(["spaBookingHeaderTitleImage"])} id="spaBookingHeaderTitleImage"/>

                        <Text style={getStyles(['widgetmainContainerHeaderTitle', 'spaBookingHeaderTitle'])} id='spaBookingHeaderTitle'>
                            {t(`spaBooking.headingSuccess`)}
                        </Text>

                        <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'spaBookingHeaderSubTitle'])} id='spaBookingHeaderSubTitle'>
                            {updateReservationDetails ? t(`spaBooking.sub_headingSuccessUpdated`) : t(`spaBooking.sub_headingSuccess`)}
                        </Text>
                    </View>
                </View>

                <View style={getStyles(['widgetmainContainerChildContainer', 'spaBookingMainContainerChildContainer'])} id='spaBookingMainContainerChildContainer'>
                    <View style={getStyles(["spaBookingSuccessContainer"])} id='spaBookingSuccessContainer'>
                        <Text style={getStyles(["spaBookingSuccessText"])} id='spaBookingSuccessText'>
                            {t("spaBooking.success_page_body").replace("#SPA_NAME", selectedService?.name)}
                        </Text>
                    </View>
                </View>
            </ScrollView>

            <View id='spaBookingNextButtonContainer' style={getStyles(['spaBookingNextButtonContainer'])}>
                <CustomPressable style={getStyles(['primaryBtn'])} onPress={() => handleNext()} id="primaryBtn">
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
                        {t("spaBooking.okay")}
                    </Text>
                </CustomPressable>
            </View>

        </View>
    )
}

export default SpaBookingSuccess
